import React from 'react'
import { useRouter } from 'next/router'

import { BCKSInvitationGuidePreview } from 'app/BCKSPage/Invitation/guidePreview'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsInvitationDocumentReviewPage {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const BCKSInvitationCollectionGuideIndexPage = (
  props: PropsInvitationDocumentReviewPage
) => {
  const router = useRouter()
  const documentName = router.query.docTitle as string

  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <BCKSInvitationGuidePreview documentName={documentName} />
}

// eslint-disable-next-line react/display-name
BCKSInvitationCollectionGuideIndexPage.Layout = ({ children }) => (
  <>{children}</>
)

export default BCKSInvitationCollectionGuideIndexPage
